export const LIBRARY_SAH = "sah";
export const LIBRARY_UMD = "umd";
